export default {
  REAL_TIME_PRICING_ERROR: 'quote/REAL_TIME_PRICING_ERROR',
  REAL_TIME_PRICING_SUCCESS: 'quote/REAL_TIME_PRICING_SUCCESS',
  SET_SWAPPED_PRINT_METHOD: 'quote/SET_SWAPPED_PRINT_METHOD',
  SHOW_SHIPPING_FORM: 'quote/SHOW_SHIPPING_FORM',
  UPDATE_COLORFUL_QUOTE: 'quote/UPDATE_COLORFUL_QUOTE',
  UPDATE_COLOR_COUNT: 'quote/UPDATE_COLOR_COUNT',
  UPDATE_DROPPED_VIEW: 'quote/UPDATE_DROPPED_VIEW',
  UPDATE_EMBROIDERY_TO_PRINT_PRICE: 'quote/UPDATE_EMBROIDERY_TO_PRINT_PRICE',
  UPDATE_HAS_FULL_QUOTE: 'quote/UPDATE_HAS_FULL_QUOTE',
  UPDATE_IS_FETCHING_PRICES_WITHOUT_DROPPED_VIEW:
    'quote/UPDATE_IS_FETCHING_PRICES_WITHOUT_DROPPED_VIEW',
  UPDATE_IS_INVENTORY_SHIPPING_TYPE: 'quote/UPDATE_IS_INVENTORY_SHIPPING_TYPE',
  UPDATE_ITEMIZED_PRICES_WITHOUT_DROPPED_VIEW:
    'quote/UPDATE_ITEMIZED_PRICES_WITHOUT_DROPPED_VIEW',
  UPDATE_ITEMIZED_PRICES: 'quote/UPDATE_ITEMIZED_PRICES',
  UPDATE_MODE: 'quote/UPDATE_MODE',
  UPDATE_NCO_ELIGIBILITY: 'quote/UPDATE_NCO_ELIGIBILITY',
  UPDATE_ONE_COLOR_LESS_PRICE: 'quote/UPDATE_ONE_COLOR_LESS_PRICE',
  UPDATE_ONE_VIEW_LESS_PRICE: 'quote/UPDATE_ONE_VIEW_LESS_PRICE',
  UPDATE_POSTAL_CODE: 'quote/UPDATE_POSTAL_CODE',
  UPDATE_PRODUCT_QUANTITIES: 'quote/UPDATE_PRODUCT_QUANTITIES',
  UPDATE_QUANTITIES_FROM_NAMES_AND_NUMBERS:
    'quote/UPDATE_QUANTITIES_FROM_NAMES_AND_NUMBERS',
  UPDATE_QUOTE_BLANK: 'quote/UPDATE_QUOTE_BLANK',
  UPDATE_QUOTE: 'quote/UPDATE_QUOTE',
  UPDATE_REAL_TIME_ITEMIZED_PRICES: 'quote/UPDATE_REAL_TIME_ITEMIZED_PRICES',
  UPDATE_REAL_TIME_TOTAL_PRICE: 'quote/UPDATE_REAL_TIME_TOTAL_PRICE',
  UPDATE_SHIPPING: 'quote/UPDATE_SHIPPING',
  UPDATE_SLEEVE_VIEW_LESS_PRICE: 'quote/UPDATE_SLEEVE_VIEW_LESS_PRICE',
  UPDATE_SLEEVE_VIEW_LESS_SAVE_AMOUNT:
    'quote/UPDATE_SLEEVE_VIEW_LESS_SAVE_AMOUNT',
  UPDATE_TOTAL_PRICE: 'quote/UPDATE_TOTAL_PRICE',
  UPDATE_UNAVAILABLE_CORE_SIZES: 'quote/UPDATE_UNAVAILABLE_CORE_SIZES'
};
